<template lang="pug">
.video-library__dashboard
  template(v-for="(category, index) in results")
    .video-library-search-content__item(v-if="!categories || categories.includes(category.category)")
      h2 {{ category.category }}
      Category(:results="category.videos")
</template>

<script>
import Category from './Category.vue';

export default {
  name: 'VideoLibraryDashboard',
  components: { Category },
  props: ['data', 'categories'],
  data() {
    return {
      results: null,
    };
  },
  methods: {
    async getData() {
      try {
        let response = await fetch(this.dashboardEndpoint);
        let data = await response.json();
        this.results = this.transformData(data.videoGroups);
      } catch (error) {
        console.log(error);

        if (this.data?.videoGroups) {
          this.results = this.transformData(this.data.videoGroups);
        }
      }
    },
    log() {
      
    },
    findVideoIdFromEmbedCode(embedCode) {
      if (this.$store.getters.results) {
        const video = this.$store.getters.results.itemResults.find((result) => result.meta.videoembedcode === embedCode);
        if (!video) {
          console.error(`Could not find video with embed code ${embedCode}`);
          return null;
        }
        return video.id || video.key || video.nodeId;
      }
    },
    transformData(data) {
      data.forEach((category, categoryIndex) => {
        category.videos.forEach((item, itemIndex) => {
          item.image = item.videoThumbnail;
          if (item.videoEmbedCode)
            item.nodeId = item.id || item.key || item.nodeId || this.findVideoIdFromEmbedCode(item.videoEmbedCode);
          item.meta = {
            longDescription: item.description,
            shortDescription: item.description,
            keywords: '',
            level: item.level,
            type: item.itemType,
            videoembedcode: item.videoEmbedCode
          }
        });
      }); 
      return data;
    },
  },
  created() {
    const location = window.location;
    this.dashboardEndpoint = `${location.origin}${this.options.dashboardEndpoint}`;
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.video-library__dashboard {
  display: contents;
}
</style>
